import React, {useCallback, useMemo} from "react";
import {Box, Select, MenuItem, FormControl, Grid} from "@mui/material";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {blue} from "@mui/material/colors";
import {styled} from "@mui/system";

import ServiceTypeTooltipLabel from "../common/ServiceTypeTooltipLabel";
import {BOOKABLE_STATUS} from "../../helpers/TimeblockHelper";

const PERFORMER_SELECTED_DARK_BLUE_COLOR = blue[700];
const BOOKABLE_SERVICES_PER_ROW = 2;

const bookableStatusDropdownStyle = {
    backgroundColor: PERFORMER_SELECTED_DARK_BLUE_COLOR,
    color: 'white',
    borderRadius: '1rem',
    height: '1.375rem',
    width: '7.188rem'
};

const bookableStatusLayout = {
    display: 'flex',
    justifyContent: {xs: 'center', lg: 'flex-start'}
};

const BookableStatusSelectBox = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
}));

const WhiteArrowDropDownIcon = (props) => <ArrowDropDownIcon {...props} style={{color: 'white'}}/>;

export default function BookableStatusSelect(props) {
    const {bookableServices, serviceTypePlans, bookableServiceTypes, setBookableServiceTypes} = props;

    const handleBookableStatusChange = useCallback((unsortedIndex, event) => {
        const updatedBookableStatusList = [...bookableServiceTypes];
        updatedBookableStatusList[unsortedIndex] = event.target.value;
        setBookableServiceTypes(updatedBookableStatusList);
    }, [bookableServiceTypes, setBookableServiceTypes]);

    const sortedBookableServices = useMemo(() =>
        bookableServices
            .map((keycode, index) => ({keycode, status: bookableServiceTypes[index], unsortedIndex: index}))
            .sort((a, b) => a.keycode.localeCompare(b.keycode)),
        [bookableServices, bookableServiceTypes]
    );

    const chunkedServices = useMemo(() => {
        const chunks = [];
        for (let i = 0; i < sortedBookableServices.length; i += BOOKABLE_SERVICES_PER_ROW) {
            chunks.push(sortedBookableServices.slice(i, i + BOOKABLE_SERVICES_PER_ROW));
        }
        return chunks;
    }, [sortedBookableServices]);

    return (
        <Box>
            {chunkedServices.map((chunk, rowIndex) => (
                <Grid container key={rowIndex} sx={bookableStatusLayout}>
                    {chunk.map((item, colIndex) => {
                        return (
                            <Grid item xs={6} key={item.unsortedIndex}  sx={{marginLeft: '0.5rem'}}>
                                <BookableStatusSelectBox>
                                    <ServiceTypeTooltipLabel service={item.keycode} serviceTypePlans={serviceTypePlans} />
                                    <FormControl>
                                        <Select
                                            value={item.status}
                                            onChange={event => handleBookableStatusChange(item.unsortedIndex, event)}
                                            size="small"
                                            style={bookableStatusDropdownStyle}
                                            IconComponent={WhiteArrowDropDownIcon}>
                                            <MenuItem value={BOOKABLE_STATUS.BOOKABLE}>{BOOKABLE_STATUS.BOOKABLE}</MenuItem>
                                            <MenuItem value={BOOKABLE_STATUS.UNBOOKABLE}>{BOOKABLE_STATUS.UNBOOKABLE}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </BookableStatusSelectBox>
                            </Grid>
                        );
                    })}
                </Grid>
            ))}
        </Box>
    );
}